import { render, staticRenderFns } from "./dashboardToolbar.vue?vue&type=template&id=8cb90408&scoped=true"
import script from "./dashboardToolbar.vue?vue&type=script&lang=js"
export * from "./dashboardToolbar.vue?vue&type=script&lang=js"
import style0 from "./dashboardToolbar.vue?vue&type=style&index=0&id=8cb90408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb90408",
  null
  
)

export default component.exports